const toggleGameInfo = ({ router, location, gameCode, listName, listGameIndex, game, transformPath }) => {
	const locationState = location?.state;
	const path = transformPath(location.pathname, {}).split('?')[0];
	const listInfo = listName && listGameIndex >= 0 ? { listName, listGameIndex } : undefined;

	const newLocationState = {
		...locationState,
		gameCode,
		...listInfo,
		game
	};

	if (locationState?.gameCode === gameCode) {
		delete newLocationState.gameCode;
	}

	if (locationState?.gameCode) {
		// TODO (navigation) - use search params or redux for state
		router.replace(path, { state: newLocationState });
	} else {
		// TODO (navigation) - use search params or redux for state
		router.push(path, { state: newLocationState });
	}
};

export default toggleGameInfo;
